export default { sha: '2326a5f3834a5eaed4a010a0b7c50a5f344c12af', buildNumber: 'undefined' }
